import { AbstractControl } from '@angular/forms';

export type Prettify<T> = { [K in keyof T]: T[K] } & Record<string, any>;
export type DeepPartial<T> = T extends object ? { [P in keyof T]?: DeepPartial<T[P]> } : T;
export type FormValue<T extends AbstractControl> = T extends AbstractControl<infer TValue, any> ? TValue : never;
export type FormRawValue<T extends AbstractControl> = T extends AbstractControl<any, infer TRawValue>
  ? TRawValue
  : never;
